/**
 * Product Card LOP - JavaScript para funcionalidad de swatches
 * Versión: 3.1.0
 * Autor: LOP Development Team
 */

console.log('LOP Product Card Swatches: Archivo cargado correctamente');

(function() {
  'use strict';

  // Configuración
  const LOP_CONFIG = {
    maxSwatches: 5,
    navigationDelay: 300,
    loadingClass: 'loading',
    errorClass: 'error',
    hoverClass: 'hover',
    carouselScrollAmount: 120, // Píxeles a desplazar en cada click
    mobileBreakpoint: 768
  };

  // Clases CSS
  const LOP_CLASSES = {
    swatchesContainer: 'LOP-product-card-swatches-container',
    swatchItem: 'LOP-product-card-swatch-item',
    swatchLink: 'LOP-product-card-swatch-link',
    swatchImage: 'LOP-product-card-swatch-image',
    swatchesWrapper: 'LOP-product-card-swatches-wrapper',
    swatches: 'LOP-product-card-swatches'
  };

  /**
   * Clase principal para manejar Product Card LOP
   */
  class ProductCardLOP {
    constructor() {
      this.initialized = false;
      this.carouselInstances = new Map();
      this.productDataCache = new Map();
      this._prefetchPromise = null;
      this.init();
    }

    /**
     * Inicializar la funcionalidad
     */
    init() {
      if (this.initialized) return;
      
      console.log('Product Card LOP: Inicializando...');
      
      // Inicializar swatches existentes
      this.initSwatches();

      // Marcar inmediatamente swatches que Liquid ya validó (data-product-available="true")
      this.markLiquidValidatedSwatches();

      // Solo prefetch handles que Liquid NO pudo validar (data-product-available="false"/"unknown")
      this._validationStartTime = performance.now();
      console.log('[PLP Validación] Inicio validación JS (solo swatches no validados por Liquid)');

      this.prefetchUnvalidatedHandles().then(() => {
        const prefetchMs = Math.round(performance.now() - this._validationStartTime);
        const total = this.productDataCache.size;
        const ok = Array.from(this.productDataCache.values()).filter(v => v != null).length;
        const fail = total - ok;
        console.log(`[PLP Validación] Prefetch completado en ${prefetchMs} ms. Cache: ${total} handles (${ok} OK, ${fail} fallidos)`);

        const tProcess = performance.now();
        this.processSwatchesFromCache();
        this.recalculateAllRemainingButtons();
        const processMs = Math.round(performance.now() - tProcess);
        const totalMs = Math.round(performance.now() - this._validationStartTime);
        console.log(`[PLP Validación] Tiempos: prefetch ${prefetchMs} ms, procesamiento DOM ${processMs} ms → swatches no-Liquid visibles en ${totalMs} ms total`);
      });
      
      // Inicializar carrusel para mobile
      this.initCarousel();
      
      // Observar cambios en el DOM para nuevos swatches
      this.observeDOM();
      
      // Observar visibilidad de swatches
      this.observeSwatchVisibility();
      
      // Verificar swatches después de la carga
      this.checkSwatchesAfterLoad();
      
      // Cargar datos de productos faltantes después de un delay
      setTimeout(() => {
        this.loadMissingProductDataWithRetry(3);
      }, 1000);
      
      // Cargar datos adicionales después de más tiempo para swatches que puedan haberse añadido dinámicamente
      setTimeout(() => {
        this.loadMissingProductDataWithRetry(2);
      }, 3000);
      
      // Recalcular botones "+X" después de que todos los productos se hayan cargado y validado
      setTimeout(() => {
        this.recalculateAllRemainingButtons();
      }, 6000);
      
      // También recalcular después de que todos los intentos de carga hayan terminado
      setTimeout(() => {
        this.recalculateAllRemainingButtons();
      }, 8000);
      
      // Escuchar cambios de tamaño de ventana para actualizar carrusel
      this.handleResize();
      
      this.initialized = true;
      console.log('Product Card LOP: Inicializado correctamente');
    }

    /**
     * Inicializar swatches existentes
     */
    initSwatches() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Card LOP: Inicializando ${swatches.length} swatches`);
      
      swatches.forEach((swatch, index) => {
        this.setupSwatch(swatch, index);
      });
    }

    /**
     * Inicializar carrusel para mobile
     */
    initCarousel() {
      if (window.innerWidth > LOP_CONFIG.mobileBreakpoint) {
        this.removeCarouselControls();
        return;
      }

      const swatchesWrappers = document.querySelectorAll(`.${LOP_CLASSES.swatchesWrapper}`);
      
      swatchesWrappers.forEach((wrapper, index) => {
        const swatchesContainer = wrapper.querySelector(`.${LOP_CLASSES.swatches}`);
        if (swatchesContainer) {
          this.setupCarousel(wrapper, swatchesContainer, index);
        }
      });
    }

    /**
     * Configurar carrusel individual
     */
    setupCarousel(wrapper, swatchesContainer, index) {
      const carouselId = `carousel-${index}`;
      
      // Limpiar controles existentes
      const existingControls = wrapper.querySelectorAll('.LOP-product-card-swatches-nav');
      existingControls.forEach(control => control.remove());
      
      // Verificar si se necesitan controles
      this.checkCarouselNeeds(wrapper, swatchesContainer, carouselId);
      
      // Añadir controles de navegación
      this.addCarouselControls(wrapper, swatchesContainer, carouselId);
      
      // Configurar eventos de scroll
      this.setupCarouselScrollEvents(swatchesContainer, carouselId);
    }

    /**
     * Verificar si el carrusel necesita controles
     */
    checkCarouselNeeds(wrapper, swatchesContainer, carouselId) {
      const swatches = swatchesContainer.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const containerWidth = swatchesContainer.offsetWidth;
      const totalSwatchesWidth = swatches.length * 30 + (swatches.length - 1) * 6; // 30px por swatch + 6px gap
      
      const needsControls = totalSwatchesWidth > containerWidth;
      
      this.carouselInstances.set(carouselId, {
        wrapper,
        container: swatchesContainer,
        needsControls,
        totalWidth: totalSwatchesWidth,
        containerWidth
      });
      
      console.log(`Product Card LOP: Carrusel ${carouselId} - Necesita controles: ${needsControls}`);
    }

    /**
     * Añadir controles de navegación al carrusel
     */
    addCarouselControls(wrapper, swatchesContainer, carouselId) {
      const carouselData = this.carouselInstances.get(carouselId);
      if (!carouselData || !carouselData.needsControls) return;
      
      // Crear botón anterior
      const prevButton = document.createElement('button');
      prevButton.className = 'LOP-product-card-swatches-nav prev';
      prevButton.innerHTML = '‹';
      prevButton.setAttribute('aria-label', 'Anterior');
      prevButton.addEventListener('click', () => {
        this.scrollCarousel(swatchesContainer, -LOP_CONFIG.carouselScrollAmount);
      });
      
      // Crear botón siguiente
      const nextButton = document.createElement('button');
      nextButton.className = 'LOP-product-card-swatches-nav next';
      nextButton.innerHTML = '›';
      nextButton.setAttribute('aria-label', 'Siguiente');
      nextButton.addEventListener('click', () => {
        this.scrollCarousel(swatchesContainer, LOP_CONFIG.carouselScrollAmount);
      });
      
      // Añadir botones al wrapper
      wrapper.appendChild(prevButton);
      wrapper.appendChild(nextButton);
      
      // Actualizar visibilidad de botones
      this.updateCarouselButtonVisibility(swatchesContainer, carouselId);
    }

    /**
     * Configurar eventos de scroll del carrusel
     */
    setupCarouselScrollEvents(swatchesContainer, carouselId) {
      let scrollTimeout;
      
      swatchesContainer.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        
        scrollTimeout = setTimeout(() => {
          this.updateCarouselButtonVisibility(swatchesContainer, carouselId);
        }, 100);
      });
    }

    /**
     * Actualizar visibilidad de botones del carrusel
     */
    updateCarouselButtonVisibility(swatchesContainer, carouselId) {
      const carouselData = this.carouselInstances.get(carouselId);
      if (!carouselData) return;
      
      const prevButton = carouselData.wrapper.querySelector('.LOP-product-card-swatches-nav.prev');
      const nextButton = carouselData.wrapper.querySelector('.LOP-product-card-swatches-nav.next');
      
      if (!prevButton || !nextButton) return;
      
      const scrollLeft = swatchesContainer.scrollLeft;
      const scrollWidth = swatchesContainer.scrollWidth;
      const clientWidth = swatchesContainer.clientWidth;
      
      // Mostrar/ocultar botón anterior
      if (scrollLeft <= 0) {
        prevButton.classList.add('hidden');
      } else {
        prevButton.classList.remove('hidden');
      }
      
      // Mostrar/ocultar botón siguiente
      if (scrollLeft >= scrollWidth - clientWidth - 1) {
        nextButton.classList.add('hidden');
      } else {
        nextButton.classList.remove('hidden');
      }
    }

    /**
     * Hacer scroll del carrusel
     */
    scrollCarousel(swatchesContainer, amount) {
      const currentScroll = swatchesContainer.scrollLeft;
      const targetScroll = currentScroll + amount;
      
      swatchesContainer.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }

    /**
     * Remover controles de carrusel
     */
    removeCarouselControls() {
      const controls = document.querySelectorAll('.LOP-product-card-swatches-nav');
      controls.forEach(control => control.remove());
      this.carouselInstances.clear();
    }

    /**
     * Manejar cambios de tamaño de ventana
     */
    handleResize() {
      let resizeTimeout;
      
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        
        resizeTimeout = setTimeout(() => {
          if (window.innerWidth <= LOP_CONFIG.mobileBreakpoint) {
            this.initCarousel();
          } else {
            this.removeCarouselControls();
          }
        }, 250);
      });
    }

    /**
     * Configurar un swatch individual (OPTIMIZADO)
     */
    setupSwatch(swatch, index) {
      if (!swatch.dataset.productHandle) {
        console.warn(`Product Card LOP: Swatch ${index} sin product handle`);
        return;
      }

      // Solo configurar si no está ya inicializado
      if (swatch.hasAttribute('data-lop-events-added')) {
        return;
      }
      
      // Marcar como configurado
      swatch.setAttribute('data-lop-events-added', 'true');
      
      // Configurar eventos en el swatch existente (sin clonado)
      this.addSwatchEvents(swatch, index);
      
      console.log(`Product Card LOP: Swatch ${index} configurado - ${swatch.dataset.productHandle}`);
    }

    /**
     * Añadir eventos a un swatch
     */
    addSwatchEvents(swatch, index) {
      const link = swatch.querySelector(`.${LOP_CLASSES.swatchLink}`);
      
      if (link) {
        // Evento de click
        link.addEventListener('click', (e) => {
          this.handleSwatchClick(e, swatch);
        });

        // Eventos de hover
        swatch.addEventListener('mouseenter', () => {
          this.handleSwatchHover(swatch, true);
        });

        swatch.addEventListener('mouseleave', () => {
          this.handleSwatchHover(swatch, false);
        });

        // Evento de focus para accesibilidad
        link.addEventListener('focus', () => {
          this.handleSwatchFocus(swatch);
        });
      }
    }

    /**
     * Manejar click en swatch
     */
    handleSwatchClick(e, swatch) {
      const productHandle = swatch.dataset.productHandle;
      if (!productHandle) {
        console.error('Product Card LOP: No se encontró product handle');
        return;
      }

      // Prevenir el comportamiento por defecto
      e.preventDefault();
      e.stopPropagation();

      // Añadir clase de carga
      swatch.classList.add(LOP_CONFIG.loadingClass);

      // Navegar al producto después del delay
      setTimeout(() => {
        try {
          window.location.href = `/products/${productHandle}`;
        } catch (error) {
          console.error('Product Card LOP: Error al navegar:', error);
          swatch.classList.remove(LOP_CONFIG.loadingClass);
          swatch.classList.add(LOP_CONFIG.errorClass);
        }
      }, LOP_CONFIG.navigationDelay);
    }

    /**
     * Manejar hover en swatch
     */
    handleSwatchHover(swatch, isEntering) {
      if (isEntering) {
        swatch.classList.add(LOP_CONFIG.hoverClass);
      } else {
        swatch.classList.remove(LOP_CONFIG.hoverClass);
      }
    }

    /**
     * Manejar focus en swatch
     */
    handleSwatchFocus(swatch) {
      // Asegurar que el swatch sea visible
      swatch.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

      /**
   * Observar cambios en el DOM (OPTIMIZADO para evitar conflictos con filtros)
   */
  observeDOM() {
    if (!window.MutationObserver) return;

    // Throttle para evitar ejecuciones excesivas
    let observerTimeout;
    const observerDelay = 1000; // 1 segundo de delay

    const observer = new MutationObserver((mutations) => {
      // Ignorar mutaciones durante procesos de filtrado
      if (document.querySelector('.collection.loading') || 
          document.querySelector('facet-filters-form')?.isProcessing) {
        return;
      }

      let shouldReinit = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Solo procesar si el nodo NO está dentro del sistema de filtros
              if (!node.closest('#ProductGridContainer') && 
                  !node.closest('facet-filters-form')) {
                if (node.classList && node.classList.contains(LOP_CLASSES.swatchItem)) {
                  shouldReinit = true;
                } else if (node.querySelector && node.querySelector(`.${LOP_CLASSES.swatchItem}`)) {
                  shouldReinit = true;
                }
              }
            }
          });
        }
      });

      if (shouldReinit) {
        // Usar throttle para evitar ejecuciones múltiples
        clearTimeout(observerTimeout);
        observerTimeout = setTimeout(() => {
          this.checkForNewSwatches();
        }, observerDelay);
      }
    });

    // Observar solo contenedores específicos, no todo el body
    const swatchContainers = document.querySelectorAll('.product-card, .products');
    if (swatchContainers.length > 0) {
      swatchContainers.forEach(container => {
        observer.observe(container, {
          childList: true,
          subtree: true
        });
      });
    } else {
      // Fallback: observar body con configuración limitada
      observer.observe(document.body, {
        childList: true,
        subtree: false // Solo primer nivel para reducir carga
      });
    }
  }

    /**
     * Observar visibilidad de swatches (OPTIMIZADO para evitar conflictos)
     */
    observeSwatchVisibility() {
      if (!window.IntersectionObserver) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // No procesar durante filtrado activo
            if (document.querySelector('.collection.loading') || 
                document.querySelector('facet-filters-form')?.isProcessing) {
              return;
            }

            const swatch = entry.target;
            const handle = swatch.dataset.productHandle;
            const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
            
            if (handle && swatchImage && (swatchImage.classList.contains('LOP-product-card-swatch-loading') || swatchImage.classList.contains('LOP-product-card-swatch-fallback'))) {
              console.log(`Product Card LOP: Swatch visible detectado - ${handle}`);
              
              // Verificar que no hay filtrado activo
              if (!document.querySelector('.collection.loading') && 
                  !document.querySelector('facet-filters-form')?.isProcessing) {
                
                this.loadProductData(handle).then(productData => {
                  if (productData) {
                    if (productData.available && productData.variants && productData.variants.some(v => v.available) && productData.published_at) {
                      this.updateSwatchWithProductData(swatch, productData);
                      console.log(`Product Card LOP: Swatch visible cargado exitosamente - ${productData.title}`);
                    } else {
                      this.hideSwatch(swatch);
                    }
                  } else {
                    this.hideSwatch(swatch);
                  }
                }).catch(error => {
                  console.error(`Product Card LOP: Error cargando swatch visible ${handle}:`, error);
                  this.hideSwatch(swatch);
                });
              }
            }
          }
        });
      }, {
        rootMargin: '600px',
        threshold: 0.1
      });

      // Observar todos los swatches existentes
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      swatches.forEach(swatch => {
        observer.observe(swatch);
      });

      // Guardar el observer para uso posterior
      this.visibilityObserver = observer;
    }

    /**
     * Añadir swatch al observador de visibilidad
     */
    addSwatchToVisibilityObserver(swatch) {
      if (this.visibilityObserver) {
        this.visibilityObserver.observe(swatch);
      }
    }

    /**
     * Verificar nuevos swatches
     */
    checkForNewSwatches() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const initializedSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}[data-lop-initialized]`);
      
      if (allSwatches.length > initializedSwatches.length) {
        console.log(`Product Card LOP: Detectados ${allSwatches.length - initializedSwatches.length} nuevos swatches`);
        
        allSwatches.forEach((swatch, index) => {
          if (!swatch.hasAttribute('data-lop-initialized')) {
            this.setupSwatch(swatch, index);
            swatch.setAttribute('data-lop-initialized', 'true');
            
            // Añadir al observador de visibilidad
            this.addSwatchToVisibilityObserver(swatch);
            
            // Intentar cargar datos inmediatamente si es necesario
            const handle = swatch.dataset.productHandle;
            const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
            
            if (handle && swatchImage && (swatchImage.classList.contains('LOP-product-card-swatch-loading') || swatchImage.classList.contains('LOP-product-card-swatch-fallback'))) {
              console.log(`Product Card LOP: Cargando datos para nuevo swatch - ${handle}`);
              
              this.loadProductData(handle).then(productData => {
                if (productData) {
                  // Verificar disponibilidad antes de actualizar
                  if (productData.available && productData.variants && productData.variants.some(v => v.available) && productData.published_at) {
                    this.updateSwatchWithProductData(swatch, productData);
                    console.log(`Product Card LOP: Nuevo swatch cargado exitosamente - ${productData.title}`);
                  } else {
                    this.hideSwatch(swatch);
                  }
                } else {
                  this.hideSwatch(swatch);
                }
              }).catch(error => {
                console.error(`Product Card LOP: Error cargando nuevo swatch ${handle}:`, error);
                this.hideSwatch(swatch);
              });
            }
          }
        });
        
        // Reinicializar carrusel si estamos en mobile
        if (window.innerWidth <= LOP_CONFIG.mobileBreakpoint) {
          setTimeout(() => {
            this.initCarousel();
          }, 100);
        }
      }
    }

    /**
     * Verificar swatches después de la carga
     */
    checkSwatchesAfterLoad() {
      setTimeout(() => {
        this.verifyAllSwatches();
      }, 2000);
    }

    /**
     * Verificar todos los swatches
     */
    verifyAllSwatches() {
      const allSwatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Card LOP: Verificando ${allSwatches.length} swatches`);
      
      allSwatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (handle && swatchImage) {
          console.log(`Product Card LOP: Swatch ${index} verificado - ${handle}`);
        } else {
          console.warn(`Product Card LOP: Swatch ${index} sin product handle`);
        }
      });
    }

    /**
     * Debug de la funcionalidad
     */
    debug() {
      console.log('Product Card LOP: Debug iniciado');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Card LOP: Total de swatches: ${swatches.length}`);
      
      swatches.forEach((swatch, index) => {
        console.log(`Product Card LOP: Swatch ${index}:`, {
          handle: swatch.dataset.productHandle,
          color: swatch.dataset.productColor,
          isCurrent: swatch.dataset.isCurrentProduct,
          hasImage: !!swatch.querySelector('img')
        });
      });
    }

    /**
     * Debug de un product card específico
     */
    debugProductCard(productCard) {
      if (!productCard) {
        console.error('Product Card LOP: No se proporcionó product card');
        return;
      }

      const swatches = productCard.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Card LOP: Product card tiene ${swatches.length} swatches`);
      
      swatches.forEach((swatch, index) => {
        console.log(`Product Card LOP: Swatch ${index} en product card:`, {
          handle: swatch.dataset.productHandle,
          color: swatch.dataset.productColor,
          isCurrent: swatch.dataset.isCurrentProduct
        });
      });
    }

    /**
     * Debug de todos los product cards
     */
    debugAllProductCards() {
      const productCards = document.querySelectorAll('.product-card');
      console.log(`Product Card LOP: Encontrados ${productCards.length} product cards`);
      
      productCards.forEach((card, index) => {
        this.debugProductCard(card);
      });
    }

    /**
     * Debug de productos agrupados
     */
    debugAgrupadorProducts(agrupadorString) {
      if (!agrupadorString) {
        console.error('Product Card LOP: No se proporcionó string de agrupador');
        return;
      }

      try {
        const agrupador = JSON.parse(agrupadorString);
        console.log('Product Card LOP: Agrupador parseado:', agrupador);
        
        if (Array.isArray(agrupador)) {
          agrupador.forEach((handle, index) => {
            console.log(`Product Card LOP: Producto ${index}: ${handle}`);
          });
        }
      } catch (error) {
        console.error('Product Card LOP: Error al parsear agrupador:', error);
      }
    }

    /**
     * Cargar datos de un producto (con cache)
     */
    loadProductData(handle) {
      if (this.productDataCache.has(handle)) {
        return Promise.resolve(this.productDataCache.get(handle));
      }

      return fetch(`/products/${handle}.js`)
        .then(response => {
          if (!response.ok) {
            console.log(`[PLP Validación] Fetch ${response.status}: ${handle}`);
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          this.productDataCache.set(handle, data);
          console.log(`[PLP Validación] Cache OK: ${handle} (${data?.title || 'sin título'})`);
          return data;
        })
        .catch(error => {
          console.error(`Product Card LOP: Error cargando datos de ${handle}:`, error);
          this.productDataCache.set(handle, null);
          return null;
        });
    }

    /**
     * Marca swatches que Liquid ya validó (data-product-available="true") como visibles
     * sin necesidad de hacer fetch. Se ejecuta sincrónicamente = instantáneo.
     */
    markLiquidValidatedSwatches() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}[data-product-available="true"]`);
      let count = 0;
      swatches.forEach(swatch => {
        if (swatch.dataset.isCurrentProduct === 'true') return;
        if (swatch.classList.contains('LOP-swatch-validated')) return;
        swatch.classList.add('LOP-swatch-validated');
        count++;
      });
      console.log(`[PLP Validación] ${count} swatches validados por Liquid (visibles inmediatamente, sin fetch)`);
    }

    /**
     * Solo prefetch handles de swatches que Liquid NO pudo validar.
     */
    prefetchUnvalidatedHandles() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const uniqueHandles = new Set();

      swatches.forEach(swatch => {
        const handle = swatch.dataset.productHandle;
        if (!handle) return;
        if (swatch.dataset.isCurrentProduct === 'true') return;
        if (swatch.dataset.productAvailable === 'true') return;
        uniqueHandles.add(handle);
      });

      const handleList = Array.from(uniqueHandles);
      console.log(`[PLP Validación] Prefetch (solo no-Liquid): ${handleList.length} handles →`, handleList);

      if (handleList.length === 0) {
        return Promise.resolve();
      }

      const promises = handleList.map(handle => this.loadProductData(handle));
      this._prefetchPromise = Promise.all(promises);
      return this._prefetchPromise;
    }

    /**
     * Prefetch all swatch handles (legacy, kept for retry logic).
     */
    prefetchAllHandles() {
      return this.prefetchUnvalidatedHandles();
    }

    /**
     * Process prefetched data: immediately hide/show swatches based on cached results.
     */
    processSwatchesFromCache() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let validados = 0;
      let ocultos = 0;
      let omitidos = 0;

      console.log(`[PLP Validación] Procesando ${swatches.length} swatches desde cache`);

      swatches.forEach(swatch => {
        if (swatch.classList.contains('LOP-swatch-disabled')) {
          omitidos++;
          return;
        }
        if (swatch.dataset.isCurrentProduct === 'true') {
          omitidos++;
          return;
        }
        if (swatch.dataset.productAvailable === 'true' && swatch.classList.contains('LOP-swatch-validated')) {
          omitidos++;
          return;
        }

        const handle = swatch.dataset.productHandle;
        if (!handle) {
          console.warn('[PLP Validación] Swatch sin handle, omitido');
          omitidos++;
          return;
        }

        if (!this.productDataCache.has(handle)) {
          console.log(`[PLP Validación] Sin cache para handle: ${handle} (omitido)`);
          omitidos++;
          return;
        }

        const productData = this.productDataCache.get(handle);
        if (productData) {
          if (productData.available && productData.variants && productData.variants.some(v => v.available) && productData.published_at) {
            this.updateSwatchWithProductData(swatch, productData);
            validados++;
            console.log(`[PLP Validación] MOSTRADO: ${handle} (${productData.title})`);
          } else {
            const motivo = !productData.available ? 'no disponible' : !productData.published_at ? 'borrador' : 'sin variantes';
            console.log(`[PLP Validación] OCULTO: ${handle} - ${motivo}`);
            this.hideSwatch(swatch);
            ocultos++;
          }
        } else {
          console.log(`[PLP Validación] OCULTO: ${handle} - 404 o error de carga`);
          this.hideSwatch(swatch);
          ocultos++;
        }
      });

      const enDom = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}.LOP-swatch-validated`).length;
      console.log(`[PLP Validación] Resumen: ${validados} mostrados, ${ocultos} ocultos, ${omitidos} omitidos → ${enDom} swatches con clase LOP-swatch-validated en DOM`);
    }

    /**
     * Actualizar swatch con datos del producto
     */
    updateSwatchWithProductData(swatch, productData) {
      if (!productData || !swatch) return;

      // Verificar si el producto está disponible
      if (!productData.available) {
        console.log(`Product Card LOP: Producto ${productData.title} no está disponible, ocultando swatch`);
        this.hideSwatch(swatch);
        return;
      }

      // Verificar si tiene variantes disponibles
      const hasAvailableVariant = productData.variants && productData.variants.some(v => v.available);
      if (!hasAvailableVariant) {
        console.log(`Product Card LOP: Producto ${productData.title} no tiene variantes disponibles, ocultando swatch`);
        this.hideSwatch(swatch);
        return;
      }

      // Verificar si el producto está publicado (no en borrador)
      // En Shopify, los productos en borrador no deberían estar disponibles, pero verificamos por si acaso
      if (productData.published_at === null || productData.published_at === '') {
        console.log(`Product Card LOP: Producto ${productData.title} está en borrador, ocultando swatch`);
        this.hideSwatch(swatch);
        return;
      }

      const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
      if (!swatchImage) return;

      // Revelar el swatch (estaba oculto por CSS hasta validación)
      swatch.style.display = '';
      swatch.style.setProperty('visibility', 'visible', 'important');
      swatch.classList.add('LOP-swatch-validated');
      swatch.classList.remove('LOP-swatch-hidden');
      console.log(`[PLP Validación] Swatch visible aplicado: ${productData.handle} (${productData.title})`);

      // Obtener la mejor imagen disponible
      let imageUrl = null;
      let imageAlt = productData.title || 'Producto';

      if (productData.featured_image) {
        imageUrl = productData.featured_image;
      } else if (productData.images && productData.images.length > 0) {
        imageUrl = productData.images[0];
      }

      if (imageUrl) {
        // Crear nueva imagen
        const newImg = document.createElement('img');
        newImg.src = imageUrl;
        newImg.alt = imageAlt;
        newImg.className = 'LOP-product-card-swatch-image';
        newImg.loading = 'lazy';
        newImg.width = 80;
        newImg.height = 80;
        
        // Añadir evento de error para fallback
        newImg.addEventListener('error', () => {
          console.warn(`Product Card LOP: Error cargando imagen para ${productData.title}`);
          this.createFallbackSwatch(swatch, productData);
        });
        
        // Añadir evento de carga exitosa
        newImg.addEventListener('load', () => {
          console.log(`Product Card LOP: Imagen cargada exitosamente para ${productData.title}`);
          swatch.classList.remove('LOP-loading', 'LOP-product-card-swatch-fallback');
          swatch.classList.add('LOP-loaded');
        });
        
        // Reemplazar el contenido del swatch
        swatchImage.parentNode.replaceChild(newImg, swatchImage);
        
        // Actualizar tooltip y datos
        if (productData.title) {
          swatch.dataset.tooltip = productData.title;
        }
        
        // Actualizar color del producto si está disponible
        if (productData.options && productData.options.length > 0) {
          const firstOption = productData.options[0];
          if (firstOption.values && firstOption.values.length > 0) {
            swatch.dataset.productColor = firstOption.values[0];
          }
        }
        
        // Actualizar URL del enlace
        const swatchLink = swatch.querySelector('.LOP-product-card-swatch-link');
        if (swatchLink && productData.url) {
          swatchLink.href = productData.url;
        }
        
        // Actualizar disponibilidad y marcar como validado
        swatch.dataset.productAvailable = 'true';
        swatch.dataset.needsLoading = 'false';
        swatch.removeAttribute('data-needs-loading');
        
        console.log(`Product Card LOP: Swatch actualizado con datos de ${productData.title}`);
      } else {
        // No hay imagen disponible, ocultar swatch
        this.createFallbackSwatch(swatch, productData);
      }
    }

    /**
     * Ocultar swatch cuando no hay imagen disponible
     */
    createFallbackSwatch(swatch, productData) {
      // En lugar de crear un fallback, ocultamos el swatch si no hay imagen
      console.log(`Product Card LOP: Ocultando swatch sin imagen para ${productData.title || 'producto desconocido'}`);
      this.hideSwatch(swatch);
    }

    /**
     * Deshabilitar swatch: lo deja invisible (via CSS) preservando su espacio en el layout.
     * No agrega LOP-swatch-validated, por lo que la regla CSS visibility:hidden sigue activa.
     */
    hideSwatch(swatch) {
      if (!swatch) return;
      if (swatch.classList.contains('LOP-swatch-disabled')) return;

      const handle = swatch.dataset.productHandle || '(sin handle)';
      console.log(`[PLP Validación] hideSwatch llamado: ${handle}`);

      swatch.classList.add('LOP-swatch-disabled');
      swatch.setAttribute('aria-hidden', 'true');
      swatch.dataset.hidden = 'true';

      swatch.classList.remove('LOP-loading', 'LOP-product-card-swatch-fallback', 'LOP-swatch-validated');
      swatch.style.setProperty('pointer-events', 'none', 'important');

      const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
      if (swatchImage) {
        swatchImage.classList.remove('LOP-product-card-swatch-loading', 'LOP-product-card-swatch-fallback');
      }

      const link = swatch.querySelector('.LOP-product-card-swatch-link');
      if (link) {
        link.style.setProperty('pointer-events', 'none', 'important');
        link.href = '#';
      }

      clearTimeout(this._recalcTimeout);
      this._recalcTimeout = setTimeout(() => {
        this.recalculateAllRemainingButtons();
      }, 150);
    }

    /**
     * Recalcular todos los botones "+X" en todos los contenedores
     */
    recalculateAllRemainingButtons() {
      const allContainers = document.querySelectorAll(`.${LOP_CLASSES.swatchesContainer}`);
      allContainers.forEach(container => {
        this.updateRemainingButton(container);
      });
    }

    /**
     * Recalcular y actualizar el botón "+X" basado en swatches visibles
     */
    updateRemainingButton(swatchesContainer) {
      if (!swatchesContainer) return;
      
      // Contar solo swatches visibles (no ocultos permanentemente)
      // Incluir tanto swatches validados como placeholders que se están cargando
      // Los placeholders no disponibles se ocultarán cuando se validen
      const allSwatches = swatchesContainer.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      const visibleSwatches = Array.from(allSwatches).filter(swatch => {
        if (swatch.classList.contains('product-card-swatches--remaining')) return false;
        if (swatch.classList.contains('LOP-swatch-disabled')) return false;
        // Only count validated swatches or current product
        return swatch.classList.contains('LOP-swatch-validated') || swatch.dataset.isCurrentProduct === 'true';
      });
      
      // Ordenar swatches por su posición en el DOM para mantener el orden correcto
      visibleSwatches.sort((a, b) => {
        const position = a.compareDocumentPosition(b);
        if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
          return -1;
        }
        if (position & Node.DOCUMENT_POSITION_PRECEDING) {
          return 1;
        }
        return 0;
      });
      
      const visibleCount = visibleSwatches.length;
      const visibleHandles = visibleSwatches.map(s => s.dataset.productHandle || '(current)');
      console.log(`[PLP Validación] Tarjeta: ${visibleCount} swatches visibles`, visibleHandles);

      const maxSwatches = 4; // Máximo de swatches a mostrar sin botón "+X"
      const maxSwatchesWithButton = 3; // Máximo de swatches a mostrar antes del botón "+X" (3 swatches + 1 botón = 4 elementos)
      
      // Encontrar el botón "+X" existente
      const existingButton = swatchesContainer.querySelector('.product-card-swatches--remaining');
      
      if (visibleCount > maxSwatches) {
        // Hay más de 4 swatches visibles, necesitamos el botón "+X"
        const remaining = visibleCount - maxSwatchesWithButton;
        
        // Mostrar solo los primeros maxSwatchesWithButton (3) y ocultar el resto
        visibleSwatches.forEach((swatch, index) => {
          if (index < maxSwatchesWithButton) {
            swatch.style.removeProperty('display');
          } else {
            swatch.style.setProperty('display', 'none', 'important');
          }
        });
        
        // Crear o actualizar el botón "+X"
        if (existingButton) {
          const span = existingButton.querySelector('span');
          if (span) {
            span.textContent = `+${remaining}`;
          }
          existingButton.dataset.remaining = remaining;
          existingButton.dataset.total = visibleCount;
          existingButton.style.removeProperty('display');
          existingButton.classList.add('LOP-remaining-validated');
          
          // Asegurarse de que el botón esté en la posición correcta (después del 3er swatch)
          if (visibleSwatches.length > maxSwatchesWithButton - 1) {
            const thirdSwatch = visibleSwatches[maxSwatchesWithButton - 1];
            if (thirdSwatch && thirdSwatch.nextSibling !== existingButton) {
              thirdSwatch.insertAdjacentElement('afterend', existingButton);
            }
          }
        } else {
          // Crear nuevo botón "+X"
          const productCard = swatchesContainer.closest('product-card');
          const productUrl = productCard ? productCard.querySelector('a[href*="/products/"]')?.href : window.location.href;
          
          const button = document.createElement('a');
          button.href = productUrl || '#';
          button.className = 'LOP-product-card-swatch-item product-card-swatches--remaining LOP-remaining-validated';
          button.dataset.href = productUrl || '#';
          button.dataset.remaining = remaining;
          button.dataset.total = visibleCount;
          button.title = `Ver ${remaining} variantes más`;
          
          const span = document.createElement('span');
          span.textContent = `+${remaining}`;
          button.appendChild(span);
          
          // Insertar después del último swatch visible (el 3ro)
          if (visibleSwatches.length > 0 && visibleSwatches[maxSwatchesWithButton - 1]) {
            visibleSwatches[maxSwatchesWithButton - 1].insertAdjacentElement('afterend', button);
          } else if (visibleSwatches.length > 0) {
            visibleSwatches[visibleSwatches.length - 1].insertAdjacentElement('afterend', button);
          } else {
            swatchesContainer.appendChild(button);
          }
        }
      } else {
        // No hay suficientes swatches, ocultar el botón "+X" si existe
        if (existingButton) {
          existingButton.style.setProperty('display', 'none', 'important');
          existingButton.classList.remove('LOP-remaining-validated');
        }
        
        // Mostrar todos los swatches visibles
        visibleSwatches.forEach(swatch => {
          swatch.style.removeProperty('display');
        });
      }
    }

    /**
     * Cargar datos de productos faltantes
     */
    loadMissingProductData() {
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let loadedCount = 0;
      let errorCount = 0;
      let skippedCount = 0;
      
      console.log(`Product Card LOP: Iniciando carga de ${swatches.length} swatches...`);
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (handle && swatchImage && (swatchImage.classList.contains('LOP-product-card-swatch-loading') || swatchImage.classList.contains('LOP-product-card-swatch-fallback'))) {
          console.log(`Product Card LOP: Cargando datos para swatch ${index + 1} - ${handle}`);
          
          // Añadir indicador de carga visual
          swatch.classList.add('LOP-loading');
          
          this.loadProductData(handle).then(productData => {
            if (productData) {
              // Verificar disponibilidad antes de actualizar
              if (productData.available && productData.variants && productData.variants.some(v => v.available) && productData.published_at) {
                this.updateSwatchWithProductData(swatch, productData);
                loadedCount++;
              } else {
                this.hideSwatch(swatch);
              }
              console.log(`Product Card LOP: Swatch ${index + 1} cargado exitosamente - ${productData.title}`);
            } else {
              errorCount++;
              console.warn(`Product Card LOP: No se pudieron cargar datos para ${handle}`);
              this.hideSwatch(swatch);
            }
            swatch.classList.remove('LOP-loading');
          }).catch(error => {
            errorCount++;
            console.error(`Product Card LOP: Error cargando ${handle}:`, error);
            swatch.classList.remove('LOP-loading');
            this.hideSwatch(swatch);
          });
        } else {
          skippedCount++;
          console.log(`Product Card LOP: Swatch ${index + 1} omitido - ya cargado o sin datos`);
        }
      });
      
      // Log del resumen después de un delay
      setTimeout(() => {
        console.log(`Product Card LOP: Resumen de carga - Cargados: ${loadedCount}, Errores: ${errorCount}, Omitidos: ${skippedCount}`);
        
        // Esperar un momento adicional para que todos los swatches se hayan validado y ocultado
        setTimeout(() => {
          // Recalcular todos los botones "+X" después de la carga y validación completa
          this.recalculateAllRemainingButtons();
        }, 1000);
      }, 3000);
    }

    /**
     * Cargar datos de productos faltantes con retry
     */
    loadMissingProductDataWithRetry(maxRetries = 3) {
      console.log(`Product Card LOP: Iniciando carga con retry (máximo ${maxRetries} intentos)...`);
      
      let attempt = 0;
      const attemptLoad = () => {
        attempt++;
        console.log(`Product Card LOP: Intento ${attempt} de ${maxRetries}`);
        
        const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
        const swatchesToLoad = Array.from(swatches).filter(swatch => {
          const handle = swatch.dataset.productHandle;
          const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
          return handle && swatchImage && (swatchImage.classList.contains('LOP-product-card-swatch-loading') || swatchImage.classList.contains('LOP-product-card-swatch-fallback'));
        });
        
        if (swatchesToLoad.length === 0) {
          console.log('Product Card LOP: No hay más swatches para cargar');
          return;
        }
        
        console.log(`Product Card LOP: Cargando ${swatchesToLoad.length} swatches en intento ${attempt}`);
        
        let loadedCount = 0;
        let errorCount = 0;
        
        const loadPromises = swatchesToLoad.map((swatch, index) => {
          const handle = swatch.dataset.productHandle;
          
          return this.loadProductData(handle).then(productData => {
            if (productData) {
              // Verificar disponibilidad antes de actualizar
              if (productData.available && productData.variants && productData.variants.some(v => v.available) && productData.published_at) {
                this.updateSwatchWithProductData(swatch, productData);
                loadedCount++;
                console.log(`Product Card LOP: Swatch cargado exitosamente - ${productData.title}`);
              } else {
                // Producto no disponible, sin variantes o en borrador - ocultar
                console.log(`Product Card LOP: Producto ${productData.title || handle} no está disponible o está en borrador, ocultando swatch`);
                this.hideSwatch(swatch);
                errorCount++;
              }
            } else {
              errorCount++;
              console.warn(`Product Card LOP: No se pudieron cargar datos para ${handle}`);
              this.hideSwatch(swatch);
            }
            swatch.classList.remove('LOP-loading');
          }).catch(error => {
            errorCount++;
            console.error(`Product Card LOP: Error cargando ${handle}:`, error);
            swatch.classList.remove('LOP-loading');
            this.hideSwatch(swatch);
          });
        });
        
        Promise.all(loadPromises).then(() => {
          console.log(`Product Card LOP: Intento ${attempt} completado - Cargados: ${loadedCount}, Errores: ${errorCount}`);
          
          // Esperar un momento para que todos los swatches se hayan validado y ocultado
          setTimeout(() => {
            // Recalcular todos los botones "+X" después de la carga y validación completa
            this.recalculateAllRemainingButtons();
          }, 1000);
          
          // Si hay errores y no hemos alcanzado el máximo de intentos, reintentar
          if (errorCount > 0 && attempt < maxRetries) {
            setTimeout(() => {
              attemptLoad();
            }, 2000 * attempt); // Delay progresivo
          }
        });
      };
      
      attemptLoad();
    }

    /**
     * Debug del estado de fallback
     */
    debugFallbackStatus() {
      console.log('Product Card LOP: Verificando estado actual de swatches...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      
      swatches.forEach((swatch, index) => {
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        const isFallback = swatchImage && swatchImage.classList.contains('LOP-product-card-swatch-fallback');
        const isLoading = swatchImage && swatchImage.classList.contains('LOP-product-card-swatch-loading');
        
        console.log(`Product Card LOP: Swatch ${index}:`, {
          handle: swatch.dataset.productHandle,
          isFallback: isFallback,
          isLoading: isLoading,
          hasImage: !!swatchImage
        });
      });
    }

    /**
     * Verificar estado actual de swatches
     */
    checkCurrentSwatchStatus() {
      console.log('Product Card LOP: Verificando estado actual de swatches...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let fallbackCount = 0;
      let loadingCount = 0;
      let loadedCount = 0;
      
      swatches.forEach((swatch, index) => {
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (swatchImage) {
          if (swatchImage.classList.contains('LOP-product-card-swatch-fallback')) {
            fallbackCount++;
          } else if (swatchImage.classList.contains('LOP-product-card-swatch-loading')) {
            loadingCount++;
          } else {
            loadedCount++;
          }
        }
      });
      
      console.log(`Product Card LOP: Resumen de swatches:`);
      console.log(`  - Total: ${swatches.length}`);
      console.log(`  - Fallback: ${fallbackCount}`);
      console.log(`  - Loading: ${loadingCount}`);
      console.log(`  - Loaded: ${loadedCount}`);
      
      return {
        total: swatches.length,
        fallback: fallbackCount,
        loading: loadingCount,
        loaded: loadedCount
      };
    }

    /**
     * Forzar carga de todos los swatches pendientes
     */
    forceLoadAllFallbackSwatches() {
      console.log('Product Card LOP: Forzando carga de todos los swatches pendientes...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      
      swatches.forEach((swatch, index) => {
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (swatchImage && (swatchImage.classList.contains('LOP-product-card-swatch-fallback') || swatchImage.classList.contains('LOP-product-card-swatch-loading'))) {
          const handle = swatch.dataset.productHandle;
          
          if (handle) {
            console.log(`Product Card LOP: Cargando datos para swatch ${index + 1} - ${handle}`);
            
            this.loadProductData(handle).then(productData => {
              if (productData) {
                // Verificar disponibilidad antes de actualizar
                if (productData.available && productData.variants && productData.variants.some(v => v.available) && productData.published_at) {
                  this.updateSwatchWithProductData(swatch, productData);
                } else {
                  // Producto no disponible, sin variantes o en borrador - ocultar
                  this.hideSwatch(swatch);
                }
              } else {
                this.hideSwatch(swatch);
              }
            });
          }
        }
      });
    }

    /**
     * Forzar carga de todos los swatches (visibles y no visibles)
     */
    forceLoadAllSwatches() {
      console.log('Product Card LOP: Forzando carga de TODOS los swatches...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let loadedCount = 0;
      let errorCount = 0;
      let skippedCount = 0;
      
      console.log(`Product Card LOP: Encontrados ${swatches.length} swatches para cargar`);
      
      const loadPromises = swatches.map((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        if (handle && swatchImage && (swatchImage.classList.contains('LOP-product-card-swatch-loading') || swatchImage.classList.contains('LOP-product-card-swatch-fallback'))) {
          console.log(`Product Card LOP: Cargando swatch ${index + 1} - ${handle}`);
          
          return this.loadProductData(handle).then(productData => {
            if (productData) {
              // Verificar disponibilidad antes de actualizar
              if (productData.available && productData.variants && productData.variants.some(v => v.available) && productData.published_at) {
                this.updateSwatchWithProductData(swatch, productData);
                loadedCount++;
                console.log(`Product Card LOP: Swatch ${index + 1} cargado exitosamente - ${productData.title}`);
              } else {
                this.hideSwatch(swatch);
              }
            } else {
              errorCount++;
              console.warn(`Product Card LOP: No se pudieron cargar datos para ${handle}`);
              this.hideSwatch(swatch);
            }
          }).catch(error => {
            errorCount++;
            console.error(`Product Card LOP: Error cargando ${handle}:`, error);
            this.hideSwatch(swatch);
          });
        } else {
          skippedCount++;
          console.log(`Product Card LOP: Swatch ${index + 1} omitido - ya cargado o sin datos`);
          return Promise.resolve();
        }
      });
      
      Promise.all(loadPromises).then(() => {
        console.log(`Product Card LOP: Carga forzada completada - Cargados: ${loadedCount}, Errores: ${errorCount}, Omitidos: ${skippedCount}`);
      });
      
      return {
        total: swatches.length,
        loaded: loadedCount,
        error: errorCount,
        skipped: skippedCount
      };
    }

    /**
     * Debug del formato de metafields
     */
    debugMetafieldFormat() {
      console.log('Product Card LOP: Verificando formato de metafields...');
      
      // Buscar elementos de debug en el DOM
      const debugElements = document.querySelectorAll('[style*="display: none"]');
      let debugInfo = null;
      
      debugElements.forEach(element => {
        if (element.textContent.includes('Debug Agrupador Original:')) {
          debugInfo = element.textContent;
        }
      });
      
      if (debugInfo) {
        console.log('Product Card LOP: Información de debug encontrada:', debugInfo);
        
        // Extraer información específica
        const originalMatch = debugInfo.match(/Debug Agrupador Original: ([^\n]+)/);
        const handlesMatch = debugInfo.match(/Debug Handles Encontrados: ([^\n]+)/);
        
        if (originalMatch) {
          console.log('Product Card LOP: Formato original:', originalMatch[1].trim());
        }
        if (handlesMatch) {
          console.log('Product Card LOP: Handles encontrados:', handlesMatch[1].trim());
        }
      } else {
        console.log('Product Card LOP: No se encontró información de debug en el DOM');
      }
      
      // Verificar swatches existentes
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Card LOP: Swatches encontrados: ${swatches.length}`);
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const color = swatch.dataset.productColor;
        const isCurrent = swatch.dataset.isCurrentProduct;
        
        console.log(`Product Card LOP: Swatch ${index + 1}:`, {
          handle: handle,
          color: color,
          isCurrent: isCurrent,
          hasImage: !!swatch.querySelector('img')
        });
      });
      
      return {
        debugInfo: debugInfo,
        swatchesCount: swatches.length
      };
    }

    /**
     * Debug del formato de metafields desde JavaScript
     */
    debugMetafieldFormatFromJS() {
      console.log('Product Card LOP: Verificando formato de metafields desde JavaScript...');
      
      // Buscar elementos de debug en el DOM
      const debugElements = document.querySelectorAll('[style*="display: none"]');
      let debugInfo = null;
      
      debugElements.forEach(element => {
        if (element.textContent.includes('Debug Agrupador Original:')) {
          debugInfo = element.textContent;
        }
      });
      
      if (debugInfo) {
        console.log('Product Card LOP: Información de debug encontrada:', debugInfo);
        
        // Extraer información específica
        const originalMatch = debugInfo.match(/Debug Agrupador Original: ([^\n]+)/);
        const handlesMatch = debugInfo.match(/Debug Handles Encontrados: ([^\n]+)/);
        
        if (originalMatch) {
          console.log('Product Card LOP: Formato original:', originalMatch[1].trim());
        }
        if (handlesMatch) {
          console.log('Product Card LOP: Handles encontrados:', handlesMatch[1].trim());
        }
      } else {
        console.log('Product Card LOP: No se encontró información de debug en el DOM');
      }
      
      // Verificar swatches existentes
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      console.log(`Product Card LOP: Swatches encontrados: ${swatches.length}`);
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const color = swatch.dataset.productColor;
        const isCurrent = swatch.dataset.isCurrentProduct;
        
        console.log(`Product Card LOP: Swatch ${index + 1}:`, {
          handle: handle,
          color: color,
          isCurrent: isCurrent,
          hasImage: !!swatch.querySelector('img')
        });
      });
      
      return {
        debugInfo: debugInfo,
        swatchesCount: swatches.length
      };
    }

    /**
     * Debug detallado del estado de swatches
     */
    debugDetailedSwatchStatus() {
      console.log('=== Product Card LOP: Debug Detallado de Swatches ===');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let totalSwatches = 0;
      let loadedSwatches = 0;
      let loadingSwatches = 0;
      let errorSwatches = 0;
      let fallbackSwatches = 0;
      
      swatches.forEach((swatch, index) => {
        totalSwatches++;
        const handle = swatch.dataset.productHandle;
        const color = swatch.dataset.productColor;
        const productName = swatch.dataset.productName;
        const isCurrent = swatch.dataset.isCurrentProduct;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        let status = 'unknown';
        if (swatch.classList.contains('LOP-loaded')) {
          status = 'loaded';
          loadedSwatches++;
        } else if (swatch.classList.contains('LOP-loading')) {
          status = 'loading';
          loadingSwatches++;
        } else if (swatch.classList.contains('LOP-error')) {
          status = 'error';
          errorSwatches++;
        } else if (swatchImage && swatchImage.classList.contains('LOP-product-card-swatch-fallback')) {
          status = 'fallback';
          fallbackSwatches++;
        }
        
        console.log(`Swatch ${index + 1}:`, {
          handle: handle,
          color: color,
          productName: productName,
          isCurrent: isCurrent,
          status: status,
          hasImage: !!swatchImage,
          imageClasses: swatchImage ? swatchImage.className : 'none'
        });
      });
      
      console.log('=== Resumen ===');
      console.log(`Total swatches: ${totalSwatches}`);
      console.log(`Cargados: ${loadedSwatches}`);
      console.log(`Cargando: ${loadingSwatches}`);
      console.log(`Errores: ${errorSwatches}`);
      console.log(`Fallbacks: ${fallbackSwatches}`);
      
      return {
        total: totalSwatches,
        loaded: loadedSwatches,
        loading: loadingSwatches,
        error: errorSwatches,
        fallback: fallbackSwatches
      };
    }

    /**
     * Verificar y reparar swatches problemáticos
     */
    repairProblematicSwatches() {
      console.log('Product Card LOP: Verificando swatches problemáticos...');
      
      const swatches = document.querySelectorAll(`.${LOP_CLASSES.swatchItem}`);
      let repairedCount = 0;
      
      swatches.forEach((swatch, index) => {
        const handle = swatch.dataset.productHandle;
        const swatchImage = swatch.querySelector('.LOP-product-card-swatch-image');
        
        // Verificar si el swatch tiene handle pero no imagen válida
        if (handle && swatchImage && swatchImage.classList.contains('LOP-product-card-swatch-loading')) {
          console.log(`Product Card LOP: Reparando swatch ${index + 1} - ${handle}`);
          
          // Intentar cargar datos nuevamente
          this.loadProductData(handle).then(productData => {
            if (productData) {
              // Verificar disponibilidad antes de actualizar
              if (productData.available && productData.variants && productData.variants.some(v => v.available) && productData.published_at) {
                this.updateSwatchWithProductData(swatch, productData);
                repairedCount++;
              } else {
                this.hideSwatch(swatch);
              }
              console.log(`Product Card LOP: Swatch ${index + 1} reparado exitosamente`);
            } else {
              this.hideSwatch(swatch);
            }
          }).catch(error => {
            console.error(`Product Card LOP: Error reparando swatch ${index + 1}:`, error);
            this.hideSwatch(swatch);
          });
        }
      });
      
      console.log(`Product Card LOP: ${repairedCount} swatches reparados`);
      return repairedCount;
    }
  }

  // Inicializar cuando el DOM esté listo (OPTIMIZADO para evitar conflictos)
  if (!window.lopSwatchesInitialized) {
    window.lopSwatchesInitialized = true;
    
    const initLOPSwatches = () => {
      try {
        // Verificar que no haya procesos de filtrado activos
        if (document.querySelector('.collection.loading')) {
          console.log('LOP Product Card Swatches: Esperando que termine el filtrado...');
          setTimeout(initLOPSwatches, 1000);
          return;
        }
        
        console.log('LOP Product Card Swatches: Inicializando de forma segura...');
        window.productCardLOPInstance = new ProductCardLOP();
      } catch (error) {
        console.error('LOP Product Card Swatches: Error durante la inicialización:', error);
      }
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        // Delay adicional para evitar conflictos con filtros
        setTimeout(initLOPSwatches, 500);
      });
    } else {
      // Delay para evitar conflictos si ya hay procesos en curso
      setTimeout(initLOPSwatches, 300);
    }
  }

  // Exponer la clase para uso externo
  window.ProductCardLOPClass = ProductCardLOP;

  // Función de utilidad para inicialización manual
  window.initProductCardLOP = function() {
    if (!window.productCardLOPInstance) {
      window.productCardLOPInstance = new ProductCardLOP();
    }
    return window.productCardLOPInstance;
  };

  // Exponer funciones para debugging
  window.debugProductCardLOP = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.debug();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar estado de swatches
  window.checkProductCardSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.checkCurrentSwatchStatus();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para forzar carga de swatches pendientes
  window.forceLoadProductCardSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.forceLoadAllFallbackSwatches();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para forzar carga de todos los swatches
  window.forceLoadAllProductCardSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.forceLoadAllSwatches();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para debug detallado
  window.debugDetailedProductCardSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.debugDetailedSwatchStatus();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para reparar swatches problemáticos
  window.repairProductCardSwatches = function() {
    if (window.productCardLOPInstance) {
      return window.productCardLOPInstance.repairProblematicSwatches();
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
      return null;
    }
  };

  // Función para verificar el estado del sistema
  window.checkLOPSystemStatus = function() {
    console.log('=== LOP System Status Check ===');
    
    // Verificar si el archivo se cargó
    console.log('✅ Archivo LOP-product-card-swatches.js cargado');
    
    // Verificar si la clase está disponible
    if (window.ProductCardLOPClass) {
      console.log('✅ Clase ProductCardLOP disponible');
    } else {
      console.log('❌ Clase ProductCardLOP NO disponible');
    }
    
    // Verificar si la instancia está disponible
    if (window.productCardLOPInstance) {
      console.log('✅ Instancia productCardLOPInstance disponible');
    } else {
      console.log('❌ Instancia productCardLOPInstance NO disponible');
    }
    
    // Verificar swatches en el DOM
    const swatches = document.querySelectorAll('.LOP-product-card-swatch-item');
    console.log(`📊 Swatches encontrados en el DOM: ${swatches.length}`);
    
    // Verificar CSS cargado
    const styles = document.querySelectorAll('link[href*="LOP-product-card-swatches.css"]');
    console.log(`🎨 Archivos CSS LOP encontrados: ${styles.length}`);
    
    // Verificar carrusel en mobile
    const isMobile = window.innerWidth <= 768;
    const carouselControls = document.querySelectorAll('.LOP-product-card-swatches-nav');
    console.log(`📱 Mobile: ${isMobile}, Controles de carrusel: ${carouselControls.length}`);
    
    return {
      fileLoaded: true,
      classAvailable: !!window.ProductCardLOPClass,
      instanceAvailable: !!window.productCardLOPInstance,
      swatchesCount: swatches.length,
      cssLoaded: styles.length > 0,
      isMobile: isMobile,
      carouselControlsCount: carouselControls.length
    };
  };

  // Función para reinicializar carrusel
  window.reinitCarousel = function() {
    if (window.productCardLOPInstance) {
      window.productCardLOPInstance.initCarousel();
      console.log('Product Card LOP: Carrusel reinicializado');
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

  // Función para debug del carrusel
  window.debugCarousel = function() {
    if (window.productCardLOPInstance) {
      const carouselInstances = window.productCardLOPInstance.carouselInstances;
      console.log('=== Product Card LOP: Debug del Carrusel ===');
      
      if (carouselInstances.size === 0) {
        console.log('No hay instancias de carrusel activas');
        return;
      }
      
      carouselInstances.forEach((data, id) => {
        console.log(`Carrusel ${id}:`, {
          needsControls: data.needsControls,
          totalWidth: data.totalWidth,
          containerWidth: data.containerWidth,
          hasControls: !!data.wrapper.querySelector('.LOP-product-card-swatches-nav')
        });
      });
    } else {
      console.log('Product Card LOP: Instancia no encontrada');
    }
  };

})(); 